import 'MarketingStyles/spots/sitecoreFormsDesign.less';

// Wait until the document is fully loaded
const callback = function () {
    formSpot();
};

if (
    document.readyState === "complete" ||
    (document.readyState !== "loading" && !document.documentElement.doScroll)
) {
    callback();
} else {
    document.addEventListener("DOMContentLoaded", callback);
}


const formSpot = () => {
    const UI = {
        fieldInputs: ".wrapper__input [data-required]",
        formReady: ".siteCoreForms .wrapper__input.ready",
        siteCoreForm: ".siteCoreForms",
        uiInputs: ".ui-input",
        submitBtn: "input[type=submit]",
        allBtnInputs: ".field-checkboxlist .wrapper__input",
        btnListLabel: ".checkboxlist-content_item",
        radioList: ".field-radiobuttonlist input.ui-input",
        fieldsWithError: ".field-validation-error:not(.error-recaptcha)",
        starIcon: ".asterisk-class",
        required: ".js-class",
        trackField: "js-track-field",
        tooltip: ".tooltip.js-validation-message",
    }
    let siteCoreForms = document.querySelectorAll(UI.siteCoreForm),
        submitBtn = document.querySelector(UI.submitBtn),
        requiredFields = assignFields(document.querySelectorAll(UI.fieldInputs)) || null,
        requiredBtnInputs = returnRequiredInputs(document.querySelectorAll(UI.allBtnInputs)) || null,
        errorFields = document.querySelectorAll(UI.fieldsWithError);

    moveAsteriskPosition(document.querySelectorAll('.field-checkboxlist .asterisk-class'));
    moveAsteriskPosition(document.querySelectorAll('.field-radiobuttonlist .asterisk-class'));

    // Assign a listener to all mandatory fields
    if (requiredFields && requiredFields.length > 0) {
        submitBtn.disabled = true;
        addValidation(requiredFields);
    }
    if (requiredBtnInputs && requiredBtnInputs.length > 0) {
        //attach an event listener to all buttonInputs
        addValidationToBtnInputs(requiredBtnInputs, 'radio');
        addValidationToBtnInputs(requiredBtnInputs, 'checkbox');
    }

    // Since it is not possible to programmatically submit the form, it was necessary to disable the btn with css to prevent multiple submissions
    if (submitBtn) {
        submitBtn.addEventListener('click', () => {
            submitBtn.classList.add('disabled');
        });
    }
    // Only display them red when it comes back with errors after submition
    if (errorFields.length > 0) {
        colorRequiredFields(errorFields);
    }
    // Separate mandatory/optional fields into new arrays to handle them
    function assignFields(fields) {
        let fieldsArr = [];
        Array.prototype.forEach.call(fields, function (field) {
            if (isFieldRequired(field)) {
                fieldsArr.push(field);
            }
        });
        return fieldsArr;
    }
    // Required Fields: Add the RegEx expression that comes from Sitecore to the client validation otherwise just check if its not empty
    function addValidation(inputs) {
        Array.prototype.forEach.call(inputs, (input) => {
            if (isFieldRequired(input)) {
                addValidationFlag(input.offsetParent);
                (areValuesEmpty(input)) ? removeClass(input.offsetParent): updateInput(input.offsetParent);
                input.addEventListener('input', () => {
                    (areValuesEmpty(input)) ? removeClass(input.offsetParent): updateInput(input.offsetParent);
                    isFormReady();
                });
            }
        });
    }

    function toggleClassDisabled() {
        const submitButton = document.querySelector(UI.submitBtn)
        if (submitButton.classList.contains('disabled')) {
            submitButton.classList.remove('disabled');
        }
    }

    function isFieldRequired(input) {
        return (input.dataset.required === "True") ? true : false;
    }

    function addValidationToBtnInputs(inputWrappers, type) {
        let inputs;
        inputWrappers.forEach((inputContainer) => {
            addValidationFlag(inputContainer);
            if (inputContainer.querySelectorAll(`input[type="${type}"]`).length > 0) {
                inputs = inputContainer.querySelectorAll(`input[type="${type}"]`);
                addEventsToListButtons(inputs, inputContainer.parentElement.querySelectorAll('.wrapper__input'));
            }
        });
    }
    // assigns a class flag to track the amount of fields that need to be validated, optional and required with Regex or not
    function addValidationFlag(inputContainer) {
        inputContainer.classList.add(UI.trackField);
    }

    // Only applied to checkboxes lists or radio lists
    function addEventsToListButtons(inputs) {
        let inputsArr = [];
        inputs.forEach(input => {
            inputsArr.push(input);
            (isAnyListInputChecked(inputsArr)) ? updateInput(input.offsetParent): removeClass(input.offsetParent);
            input.addEventListener('input', () => {
                (areValuesEmpty(input)) ? removeClass(input.offsetParent): updateInput(input.offsetParent);
                (isAnyListInputChecked(inputsArr)) ? updateInput(input.offsetParent): removeClass(input.offsetParent);
                isFormReady();
            });
        });
    }

    function removeClass(input) {
        input.classList.remove("ready");
    }

    function updateInput(input) {
        if (input.classList.contains('ready')) {
            return
        } else {
            input.classList.add('ready');
        }
    }
    // Resets radios and checkboxes. Used in case there are errors back from Backend, so the client validation can kick off again.
    function resetChecksAndRadios(inputParent) {
        if (inputParent.length > 0) {
            // check if any input is checked and set it to false
            Array.prototype.forEach.call(inputParent, function (inputs) {
                let buttonsInputs = inputs.querySelectorAll(UI.uiInputs);
                buttonsInputs.forEach(input => {
                    if (input.checked) {
                        input.checked = false;
                        removeClass(input.offsetParent);
                    }
                });

            });
        }
    }
    // Return required inputs only
    function returnRequiredInputs(inputElements) {
        let newArr = [];
        if (inputElements.length > 0) {
            Array.prototype.forEach.call(inputElements, function (element) {
                if (isFieldRequired(element)) {
                    newArr.push(element);
                }
            });
            return newArr;
        }
    }

    function isAnyListInputChecked(inputs) {
        let checked = false;
        Array.prototype.forEach.call(inputs, (input) => {
            if (input.checked) {
                return checked = true;
            }
        });
        return checked;
    }

    function areValuesEmpty(input) {
        let result = false;
        (input.value) ? result = false: result = true;
        return result;
    }

    function isFormReady() {
        let readyInputs = document.querySelectorAll(UI.formReady).length,
            trackedInputs = document.querySelectorAll(`.${UI.trackField}`).length;
        //console.log('readyInputs: ', readyInputs, 'trackedInputs: ', trackedInputs);
        if (readyInputs === trackedInputs) {
            submitBtn.disabled = false;
            toggleClassDisabled();
        } else {
            submitBtn.disabled = true;
        }
    }

    // Check if the asterisk label is empty or has text and apply a class
    function moveAsteriskPosition(fields) {
        if (fields.length > 0) {
            fields.forEach(field => {
                if (!field.parentElement.innerText) {
                    field.classList.add('alt');
                }
            });
        }
    }
    // Color the field borders red if the required input is empty
    function colorRequiredFields(fields) {
        // Start the form without any checked inputs 
        resetChecksAndRadios(document.querySelectorAll(UI.allBtnInputs));
        if (fields.length > 0) {
            fields.forEach(field => {
                field.previousElementSibling.classList.add('field-error');
            });
        }
        isFormReady();
    }

    if (siteCoreForms.length > 0) {
        for (var i = 0; i < siteCoreForms.length; i++) {
            var hiddenInputs = siteCoreForms[i].querySelectorAll('input.hidden');

            if (hiddenInputs.length > 0) {
                for (var j = 0; j < hiddenInputs.length; j++) {
                    var wrapper = hiddenInputs[j].parentElement.parentElement;

                    if (wrapper.classList.contains('wrapper')) {
                        wrapper.classList.add('hidden');
                    }
                }
            }
        }
    }
    // fix for input type file, otherwise when submitting, Sitecore crashes.
    let sitecoreForm = document.querySelector('form'),
        sitecoreFormField = document.querySelector('#sitecoreFormFileId') || null,
        inputFileInput = document.querySelectorAll('form input[type=file]');
    sitecoreForm.addEventListener('submit', () => {
        if (sitecoreFormField && sitecoreFormField.value != undefined) {
            console.log('ran');
            if (inputFileInput.length != 0) {
                inputFileInput.forEach(input => {
                    if (input.files.length == 0) {
                        input.remove();
                    }
                });
            }
        }
    });
}